module.exports = __webpack_public_path__ + "assets/img/17_1607.e71b3ca0.jpg";